import pug from 'javascripts/notifications/templates/notifications_container.jst.pug';
window.JST = window.JST || {};
window.JST['notifications/templates/notifications_container'] = pug;
